/** Business motivation lines shown while Video Studio generations run. */
export const GENERATION_MOTIVATION_QUOTES = [
  "Proper planning never goes wasted.",
  "Any investment without proper research may be seen as a gamble.",
  "You don't wait to get big to plan big. You plan at every stage.",
  "Nothing works without someone at work.",
  "If it is easy, everyone will be doing it.",
  "Discipline beats motivation when the excitement fades.",
  "Small consistent steps still move the needle.",
  "Clarity turns effort into progress.",
  "Don't confuse motion with progress — measure what matters.",
  "The best time to start was yesterday. The next best time is now.",
  "Build systems, not just goals.",
  "Patience is a business strategy, not a delay tactic.",
  "Your network grows when your value is clear.",
  "Focus is a competitive advantage.",
  "Ship, learn, improve — then ship again.",
  "Consistency compounds faster than intensity alone.",
  "Protect your attention like capital.",
  "Problems are invitations to invent better solutions.",
  "A clear brief saves hours of rework.",
  "Quality is remembered long after speed is forgotten.",
  "Listen more than you pitch.",
  "Customers don't buy products — they buy outcomes.",
  "Cash flow keeps vision alive.",
  "Reputation is earned in quiet seasons.",
  "Say no to noise so you can say yes to growth.",
  "Execution turns ideas into assets.",
  "Every expert was once a beginner who stayed.",
  "Prepare for luck by being ready when it arrives.",
  "Ownership starts where excuses end.",
  "Progress loves a deadline with a plan.",
  "Don't wait for perfect conditions — create workable ones.",
  "Service is the shortest path to trust.",
  "Learn from competitors; copy only what fits your mission.",
  "Energy management beats time management.",
  "Document what works so success can repeat.",
  "Risk managed well is opportunity unlocked.",
  "The market rewards those who finish.",
  "Feedback is free consulting — use it wisely.",
  "Stay curious longer than you stay comfortable.",
  "Your brand is what people say when you're not in the room.",
  "Strategy without action is a wish list.",
  "Action without strategy is expensive noise.",
  "Hire slow, decide clear, move fast.",
  "Margins matter as much as milestones.",
  "Today's practice builds tomorrow's reputation.",
  "Keep promises smaller than your capacity to deliver.",
  "Innovation starts by questioning the default.",
  "Calm leaders make better decisions under pressure.",
  "Invest in skills that compound for decades.",
  "Gratitude keeps ambition grounded.",
  "Finish strong — completion creates momentum.",
  "Vision without work is a daydream; work without vision is a grind.",
];

/**
 * Pick a random quote index different from the current one when possible.
 * @param {number} currentIndex
 * @param {number} length
 */
export function nextMotivationIndex(currentIndex, length = GENERATION_MOTIVATION_QUOTES.length) {
  if (length <= 1) return 0;
  let next = Math.floor(Math.random() * length);
  if (next === currentIndex) {
    next = (next + 1) % length;
  }
  return next;
}
